module.exports = __webpack_public_path__ + "media/images/how-img-1024-da770f8a3c09c8a6300e91f0f1cc8fd0.png";